import { render, staticRenderFns } from "./FiModal.vue?vue&type=template&id=7b2e3470&lang=pug&"
import script from "./FiModal.vue?vue&type=script&lang=js&"
export * from "./FiModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports